import { faArrowUpRight } from '@fortawesome/pro-light-svg-icons/faArrowUpRight'
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink'
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'

import Button from '@space-lib/components/button'
import { Emoji } from '@space-lib/components/emoji'
import Icon from '@space-lib/components/icon'
import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import type { ExternalLinkListProps } from './types'

import { ExternalLinkDropdown } from '../externalLinkDropdown'

const Wrapper = styled.div`
  transition: background-color var(--timing) var(--easing);

  :hover {
    background-color: var(--custom-color-lighter);
  }

  :active {
    background-color: var(--gray-100) !important;
  }
`

const LinkName = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
`

const WrapperIcon = styled.div`
  width: 1.5rem;
`

const ExternalLinkList = ({
  linkList,
  isOwner,
  handleAddLink,
  handleEditLink,
  handleRemoveLink
}: ExternalLinkListProps) => {
  const { t } = useTranslation()

  function handleOpenUrl(url: string) {
    window.open(url, '_blank')
  }

  return (
    <>
      {linkList?.map((link) => (
        <Wrapper
          key={`external-link-${link.id}`}
          className='_w-full _d-flex _align-items-center _rounded _p-4'>
          <button
            onClick={() => handleOpenUrl(link.url)}
            className='_flex-1 _d-flex _align-items-center _justify-content-between _bg-transparent _border-0 _rounded _cursor-pointer _text-gray-900 _p-0'>
            <div className='_d-flex _align-items-center _justify-content-start'>
              <WrapperIcon className='_mr-2'>
                {link?.icon ? <Emoji id={link.icon} /> : <Icon icon={faLink} />}
              </WrapperIcon>
              <LinkName className='_font-14 _ml-2 _mb-0'>{link.name}</LinkName>
            </div>
            {!isOwner && <Icon icon={faArrowUpRight} />}
          </button>

          {isOwner && (
            <ExternalLinkDropdown
              handleEditLink={() => handleEditLink(link)}
              handleRemoveLink={() => handleRemoveLink(link.id)}
            />
          )}
        </Wrapper>
      ))}

      {isOwner && (
        <Button
          variation='tertiary'
          onClick={handleAddLink}
          className='_py-3 _text-1 _text-gray-900 _d-flex _align-items-center _w-full'>
          <Icon icon={faPlus} className='_mr-4' />
          <span>{t('external_links.add')}</span>
        </Button>
      )}
    </>
  )
}

export default ExternalLinkList
